import React from 'react';
import { Box, CSSObject, Grid, IconButton, Theme } from '@mui/material';
import MuiDrawer from '@mui/material/Drawer';
import { useResize } from 'hooks/common';
import CloseIcon from '@mui/icons-material/Close';

type RunSparkModalSideBarProps = {
  open: boolean;
  toggleOpen: () => void;
  children: React.ReactNode;
};

const openedMixin = (theme: Theme, isMobile: boolean): CSSObject => ({
  width: '25%',
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  top: isMobile ? 0 : '6rem',

  overflowX: 'hidden',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
});

const closedMixin = (theme: Theme, isMobile: boolean): CSSObject => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  top: isMobile ? 0 : '6rem',

  overflowX: 'hidden',
  width: 0,
});

function RunSparkModalSideBar({
  open,
  toggleOpen,
  children,
}: RunSparkModalSideBarProps) {
  const { isMobile } = useResize();

  return (
    <MuiDrawer
      variant='permanent'
      component='div'
      anchor='left'
      sx={(theme) => ({
        position: 'relative',

        '& .MuiPaper-root': {
          top: '4rem',
          borderLeft: `1px solid ${theme.palette.borderColor}`,
          borderRadius: '0px !important',
        },
        ...(open && {
          ...openedMixin(theme, isMobile),
          '& .MuiDrawer-paper': openedMixin(theme, isMobile),
        }),
        ...(!open && {
          ...closedMixin(theme, isMobile),
          '& .MuiDrawer-paper': closedMixin(theme, isMobile),
        }),
        ...(!isMobile && {
          ...openedMixin(theme, isMobile),
          '& .MuiDrawer-paper': openedMixin(theme, isMobile),
        }),
      })}
    >
      <Grid p={4}>
        {isMobile && (
          <Box display='flex' justifyContent='flex-end'>
            <IconButton onClick={() => toggleOpen()}>
              <CloseIcon />
            </IconButton>
          </Box>
        )}

        <>{children}</>
      </Grid>
    </MuiDrawer>
  );
}

export default RunSparkModalSideBar;
